import {
  Typography,
  Dialog as MUIDialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
} from "@mui/material";
import { CloseOutlined } from "@mui/icons-material";

import { colors } from "../../css components/Style";

export default function ViewAgreement({ viewAgreement, setViewAgreement }) {
  const handleClose = () => {
    setViewAgreement({
      data: viewAgreement?.data,
      state: false,
    });
  };

  return (
    <MUIDialog
      open={viewAgreement?.state}
      onClose={handleClose}
      PaperProps={{
        sx: {
          minWidth: "95%",
          height: "100%",
          maxHeight: "calc(100% - 140px)",
          borderRadius: "12px",
        },
      }}
    >
      <DialogTitle sx={{ p: "8px 24px" }}>
        <Grid container alignItems="center">
          <Grid size={7}>
            <Typography color={colors.publicisBlue} variant="h4">
              View Agreement
            </Typography>
          </Grid>

          <Grid size={5} textAlign="end">
            <IconButton onClick={handleClose}>
              <CloseOutlined />
            </IconButton>
          </Grid>
        </Grid>
      </DialogTitle>

      <DialogContent sx={{ height: "100%", p: 0 }}>
        <iframe
          title="View Agreement"
          src={`${
            viewAgreement.data.is_verified
              ? viewAgreement.data?.signed_agreement_link
              : viewAgreement.data?.unsigned_agreement_link
          }#zoom=100`}
          style={{
            width: "100%",
            height: "100%",
            border: "none",
          }}
        ></iframe>
      </DialogContent>
    </MUIDialog>
  );
}
